import { useSSRQuery } from '../../../graphql';

import USER_MENU_QUERY from './userMenu/userMenu.query.graphql.js';
import USER_SUMMARY_QUERY from './userMenu/userSummary.query.graphql.js';

const useUserMenuQuery = ({ skipSummary = false }) => {
  const {
    loading: userMenuLoading,
    error: userMenuError,
    data: userMenuData,
    refetch: refetchUserMenu,
  } = useSSRQuery(USER_MENU_QUERY, {
    notifyOnNetworkStatusChange: true,
  });

  const {
    loading: summaryLoading,
    error: summaryError,
    data: summaryData,
  } = useSSRQuery(USER_SUMMARY_QUERY, {
    fetchPolicy: 'network-only',
    skip: skipSummary,
  });

  const loading = userMenuLoading || summaryLoading;
  const error = userMenuError || summaryError;

  if (loading || error) {
    return {
      loading,
      error,
      userMenuData: null,
      summaryData: null,
      refetchUserMenu,
    };
  }

  const { userMenu } = userMenuData.application;

  let summary = null;

  if (!skipSummary) {
    const {
      loyaltyId: id,
      firstName,
      lastName,
      loyalty,
      isLoyaltyCardLinked,
    } = summaryData.viewer;

    summary = {
      id,
      firstName,
      lastName,
      loyalty,
      isLoyaltyCardLinked,
    };
  }

  return {
    userMenuItems: userMenu,
    loading,
    error,
    refetchUserMenu,
    ...summary,
  };
};

export default useUserMenuQuery;
